import React from "react";

// components
import Bio from "../Bio";

// assets
import bioImg from "../../../assets/images/StratCap-ToddRowley.jpg";

const ToddRBio = (props) => {
  const bioData = {
    title: "Todd Rowley",
    title2: "Chief Executive Officer",
    hashName: "todd-rowley",
    bio1: `Todd A. Rowley is a seasoned telecommunications executive with over three decades of telecom
    industry experience, including wireless, wireline, cable television, and other related industries.
    Mr. Rowley serves as the Chief Executive Officer and Chief Investment Officer of the fund’s
    advisor and is responsible for identifying and structuring wireless infrastructure investment
    opportunities. Mr. Rowley also serves as a member of the investment committee of the advisor
    and on the Board of Directors. He has an extensive background in corporate and business
    development and strategy and has also held several significant operating roles. Over his career,
    Mr. Rowley has led or participated in dozens of transactions accounting for over $125 billion
    in value. He has extensive experience with strategic partnering, M&A transactions, strategic
    analysis, financings, joint ventures, evaluating and developing new business opportunities, and
    complex negotiations.`,
    bio2: `Mr. Rowley spent 17 years in various executive roles at Sprint. During his tenure, he managed Sprint’s
    extensive spectrum portfolio, led dozens of spectrum transactions, and established the company’s overall spectrum and
    roaming strategies. He was also a key member of the team that evaluated and made critical technology decisions related
    to 3G, 4G, LTE, and WiMAX, and then led efforts to contract with vendors such as Samsung, Nokia, Motorola, Ericsson,
    Qualcomm, and Intel. He led and managed the deployment of 4G/WiMAX for Sprint, one of the country’s first 4G products,
    and, together with his team, managed all aspects of the 4G roll-out, including product, pricing, marketing, sales, distribution,
    network, and care. Mr. Rowley holds a Bachelor’s in Business Administration with majors in finance and marketing from the
    University of Iowa.`,
    bio3: ``,
  };
  return (
    <Bio
      srcImg={bioImg}
      title1={bioData.title}
      title2={bioData.title2}
      hashName={bioData.hashName}
      bio1={bioData.bio1}
      bio2={bioData.bio2}
      bio3={bioData.bio3}
      closeBio={props.closeBio}
    />
  );
};

export default ToddRBio;
